import React from 'react';

import { i18n } from '@lt/localization';
import { TouristDateField } from './index';
import { GENDER } from '../../../routes/Checkout/store/constants/tourists';

export default class TouristBirthday extends React.PureComponent {
  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { gender, age, ...other } = this.props;
    const label =
      gender ===
      i18n.t('checkout.touristForm.gender', {
        context: GENDER.MALE ? 'male' : 'female',
      });
    return <TouristDateField {...other} label={label} />;
  }
}

TouristBirthday.propTypes = {};
